<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M43.56 22.94l-18.5-18.5a1.49 1.49 0 00-2.12 0l-18.5 18.5a1.5 1.5 0 002.12 2.12l.44-.44V42.5A1.5 1.5 0 008.5 44h11a1.5 1.5 0 001.5-1.5V32h6v10.5a1.5 1.5 0 001.5 1.5h11a1.5 1.5 0 001.5-1.5V24.62l.44.44a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12zM38 41h-8V30.5a1.5 1.5 0 00-1.5-1.5h-9a1.5 1.5 0 00-1.5 1.5V41h-8V21.62l14-14 14 14z"/></svg>